export const barChart = {
  name: "bar-chart" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M13.364 2.864A.9.9 0 0 1 14 2.6h5a.9.9 0 0 1 .9.9v16.1h1.6a.9.9 0 0 1 0 1.8h-19a.9.9 0 1 1 0-1.8h1.6V13a.9.9 0 0 1 .9-.9h3.6V10a.9.9 0 0 1 .9-.9h3.6V3.5a.9.9 0 0 1 .264-.636ZM13.1 10.9h-2.7v8.7h2.7v-8.7Zm1.8 8.7h3.2V4.4h-3.2v15.2Zm-6.3 0v-5.7H5.9v5.7h2.7Z" clip-rule="evenodd"/></svg>`,
  keywords: ["bar-chart"],
  category: "file" as const,
};
